import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const Users = lazy(() => import('../../container/pages/main-users/index'));

function UsersRoutes() {
  return (
    <Routes>
      <Route index element={<Users />} />
    </Routes>
  );
}

export default UsersRoutes;
